import { ReactElement, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Button, Stack } from "@mui/material";

import ConfirmationButton from "../components/shared/ConfirmationButton";
import PageContainer from "../components/shared/PageContainer";
import TemplateSetForm from "../components/template-set/TemplateSetForm";
import { Profile, Profiles, TemplateSet, TemplateSets } from "../services/api";
import { DefaultSetID } from "../services/api/TemplateSets";

function TemplateSetCreate() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [templateSet, setTemplateSet] = useState<TemplateSet>(
    new TemplateSet({ id: "", name: "", template_names: [], disabled: false }),
  );
  const [profiles, setProfiles] = useState<Profile[]>([]);

  const handleUpdate = async () => {
    await templateSet.update();
    navigate("/template-sets");
  };

  const handleDelete = async () => {
    templateSet.disabled = true;
    await templateSet.update();
    navigate("/template-sets");
  };

  const renderActionButtons = (): ReactElement => {
    const hasError = templateSet.hasErrors(templateSet.validate());
    return (
      <Stack direction="row" spacing={1}>
        <Button
          sx={{ marginRight: "7pt", marginTop: "10pt" }}
          onClick={handleUpdate}
          variant="contained"
          disabled={hasError}
        >
          Update
        </Button>
        <ConfirmationButton
          sx={{ marginTop: "10pt" }}
          onConfirm={handleDelete}
          variant="contained"
          dialogTitle="Confirm Deletion"
          dialogMessage={`Are you sure you want to delete "${templateSet.name}"?`}
          disabled={templateSet.id === DefaultSetID}
        >
          Delete
        </ConfirmationButton>
      </Stack>
    );
  };

  useEffect(() => {
    Profiles.list().then(setProfiles);
  }, []);

  useEffect(() => {
    TemplateSets.retrieve(id!).then((ts) =>
      setTemplateSet(
        new TemplateSet({
          id: ts.id,
          name: ts.name,
          template_names: ts.templates?.flatMap((t) => t.name),
          disabled: ts.disabled,
        }),
      ),
    );
  }, [id]);

  return (
    <PageContainer>
      {templateSet.id && (
        <TemplateSetForm
          actionButtons={renderActionButtons()}
          isUpdate={true}
          templateSet={templateSet}
          setTemplateSet={setTemplateSet}
          profiles={profiles}
        ></TemplateSetForm>
      )}
    </PageContainer>
  );
}

export default TemplateSetCreate;
